import { Badge, Col, Divider, List, Row } from "antd";
import React, { useCallback, useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  StatusFilters,
  statusProcess,
  StatusWithEle,
  STATUS_ARRAY,
  STRING_DATE,
} from "../../../const/constant";
import { dataWrapper } from "../../../redux/actions";
import { Claim } from "../../../types/RequestTypes";
import { ClaimDataType, ClaimDtlDataType } from "../../../types/TableTypes";
import addKey from "../../../utility/addKeys";
import formatAmount from "../../../utility/formatAmount";
import dayjs from "dayjs";
import { ExpandableConfig } from "antd/es/table/interface";
import TableWithCollapse from "../../component/TableWithCollapse";

function ClaimDetailsTable(props) {
  const { claims, device, hideCol } = props;
  //state Info (Data in Table)
  const [claimInfo, setClaimInfo] = useState<ClaimDataType[]>();

  //Table Key expand states
  const [expandKeys, setExpandKeys] = useState<React.Key[]>([]);

  //Ref for all keys in duty
  //const duty_keys = useRef<{[DUTY_PK : number]: React.Key[]}>({});
  const transformDtlData = useCallback((claims: Claim[]) => {
    const statusArr: string[] = [...STATUS_ARRAY];
    let c_r: ClaimDataType[] = [];
    for (const claim of claims) {
      if (!statusArr.includes(claim.STATUS)) {
        continue;
      }
      const newStatus = statusProcess(claim);
      let i: ClaimDataType = {
        key: claim.SP_SUP_CLAIM_PK,
        AMOUNT: formatAmount(claim.TOT_CLAIM_AMT),
        DATE: `${dayjs(claim.START_DATE).format(STRING_DATE)} to ${dayjs(
          claim.END_DATE
        ).format(STRING_DATE)}`,
        STATUS: newStatus,
        startDate: claim.START_DATE,
        statusSeq: newStatus === "PP" ? 6 : claim.STATUS_SEQ,
        TIME: `${claim.TOT_HR_CLAIM} hr(s)`,
        SP_SUP_CLAIM_PK: claim.SP_SUP_CLAIM_PK,
        BATCH_REF: claim.BATCH_NO,
        SUBMIT_DATE:
          claim.SUBMIT_DATE &&
          `${dayjs(claim.SUBMIT_DATE).format(STRING_DATE)}`,
        ENDORSER: claim.ENDORSER,
        APPROVER: claim.APPROVER,
        APP_DATE:
          claim.APP_DATE && `${dayjs(claim.APP_DATE).format(STRING_DATE)}`,
        REVIEW_DATE:
          claim.REVIEW_DATE &&
          `${dayjs(claim.REVIEW_DATE).format(STRING_DATE)}`,
        REMARKS: claim.REMARKS,
        CLAIM_DTL: [],
      };
      if (claim.CLAIMS_DETAILS) {
        let index = 0;
        for (const claim_dtl of claim.CLAIMS_DETAILS) {
          i.CLAIM_DTL?.push({
            key: `${claim.SP_SUP_CLAIM_PK}_${index}`,
            DTL_DATE: `${dayjs(claim_dtl.CLAIM_DATE).format(STRING_DATE)}`,
            DTL_TIME: `${claim_dtl.HR_CLAIM} hr(s)`,
          });
          ++index;
        }
      }
      //Filter Conditions for table
      if (claim.TOT_CLAIM_AMT !== null) {
        c_r.push(i);
      }
    }
    return c_r;
  }, []);

  const RenderBadge = (record) => {
    let newStatus = statusProcess(record);
    return (
      <Badge
        style={{ display: "flex", alignItems: "center" }}
        {...StatusWithEle[newStatus]}
      />
    );
  };

  useEffect(() => {
    if (claims) {
      setClaimInfo(addKey(transformDtlData(claims)));
    }
  }, [claims, transformDtlData]);

  const claim_columns = [
    { title: "Date", dataIndex: "DATE", key: "DATE" },
    { title: "Time / Hours", dataIndex: "TIME", key: "TIME" },
    { title: "Amount", dataIndex: "AMOUNT", key: "AMOUNT" },
    {
      title: "Status",
      key: "STATUS",
      render: (text, record, index) => RenderBadge(record),
      responsive: ["md"],
      ...StatusFilters,
    },
  ];

  const ColshowOnExpand = {
    TIME: { desktop: false, tablet: false, mobile: false },
    DATE: { desktop: false, tablet: false, mobile: false },
    AMOUNT: { desktop: false, tablet: false, mobile: false },
    STATUS: { desktop: false, tablet: false, mobile: true },
    BATCH_REF: { desktop: true, tablet: true, mobile: true },
    SUBMIT_DATE: { desktop: true, tablet: true, mobile: true },
    ENDORSER: { desktop: true, tablet: true, mobile: true },
    APPROVER: { desktop: true, tablet: true, mobile: true },
    APP_DATE: { desktop: true, tablet: true, mobile: true },
    REVIEW_DATE: { desktop: true, tablet: true, mobile: true },
    REMARKS: { desktop: true, tablet: true, mobile: true },
  };

  const dutyTitle = {
    TIME: "Time",
    DATE: "Date",
    AMOUNT: "Amount",
    STATUS: "Status",
    BATCH_REF: "Batch Reference",
    SUBMIT_DATE: "Staff Submission Date",
    ENDORSER: "Endorser",
    APPROVER: "Approver",
    APP_DATE: "Approved on",
    REVIEW_DATE: "Endorsed on",
    REMARKS: "Remarks",
  };

  const isSearchTable = {
    DATE: true,
    TIME: true,
    AMOUNT: true,
    STATUS: false,
  };

  const claimDtl = (claimDtls: ClaimDtlDataType[]) => {
    const result = claimDtls.sort(
      (a: ClaimDtlDataType, b: ClaimDtlDataType) => {
        const dtlDateA = new Date(a.DTL_DATE);
        const dtlDateB = new Date(b.DTL_DATE);

        if (dtlDateA < dtlDateB) {
          return -1;
        } else if (dtlDateA > dtlDateB) {
          return 1;
        } else {
          return 1;
        }
      }
    );
    return result;
  };

  const claimExpandable: ExpandableConfig<ClaimDataType> = {
    expandedRowRender: (record) => {
      const col: JSX.Element[] = [];
      const recordClaimDtlByOrder =
        record?.CLAIM_DTL && record?.CLAIM_DTL?.length
          ? claimDtl(record.CLAIM_DTL)
          : [];
      for (const [key, value] of Object.entries(record)) {
        let valueCol = (
          <Col key={`${key}_size`} span={18}>
            {value}
          </Col>
        );
        if (key === "STATUS") {
          valueCol = (
            <Col key={`${key}_size`} span={18}>
              {RenderBadge(record)}
            </Col>
          );
        }
        if (ColshowOnExpand?.[key]?.[device.size] === true && value) {
          let rowTitle = dutyTitle[key];
          if (record.STATUS === "R") {
            if (
              (key === "APP_DATE" && record.APPROVER) ||
              (key === "REVIEW_DATE" && !record.APPROVER && record.ENDORSER)
            ) {
              rowTitle = "Rejected on";
            }
          }
          col.push(
            <Row key={key}>
              <Col span={6}>{`${rowTitle} :`}</Col>
              {valueCol}
            </Row>
          );
        }
      }
      return (
        <div>
          {col.length > 0 && (
            <div>
              <div style={{ padding: "8px 0" }}>{col}</div>{" "}
              <Divider style={{ margin: "1rem 0 0 0" }} />
            </div>
          )}
          {recordClaimDtlByOrder.length ? (
            <List
              dataSource={record.CLAIM_DTL}
              renderItem={(item) => (
                <List.Item style={{ padding: "1rem 0" }}>
                  <Row style={{ width: "100%" }}>
                    <Col span={6}>Date :</Col>{" "}
                    <Col span={18}>{item.DTL_DATE}</Col>
                    <Col span={6}>Time :</Col>{" "}
                    <Col span={18}>{item.DTL_TIME}</Col>
                  </Row>
                </List.Item>
              )}
            />
          ) : (
            <></>
          )}
        </div>
      );
    },
    rowExpandable: (record) => {
      let showCol = false;
      for (const [key, value] of Object.entries(record)) {
        if (ColshowOnExpand?.[key]?.[device.size] === true && value) {
          showCol = true;
        }
      }
      showCol =
        showCol || (record.CLAIM_DTL ? record.CLAIM_DTL.length > 0 : false);
      return showCol;
    },
    onExpand: (expanded, record) => {
      let keys = expandKeys;
      if (expanded && !keys.includes(record.key)) {
        keys.push(record.key);
      } else if (!expanded && keys.includes(record.key)) {
        keys = keys.filter((i) => i !== record.key);
      }
      setExpandKeys(keys);
    },
    expandedRowKeys: expandKeys,
  };

  return (
    <TableWithCollapse
      data={claimInfo}
      columns={claim_columns}
      expandable={claimExpandable}
      isSearchTable={isSearchTable}
      isRequestPage={true}
      hideCol={hideCol}
    />
  );
}

const mapStateToProps = (state) => {
  return {
    device: state.session.device,
  };
};

const mapDispatchToProps = (dispatch) => ({
  dataFetch: (apiPath, data, method) => {
    return dispatch(dataWrapper(apiPath, data, method));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ClaimDetailsTable);
